import React from 'react'
import { HudsonLampDemo } from '../components/ui/hudson-lamp'

const LampDemoPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <HudsonLampDemo />
    </div>
  )
}

export default LampDemoPage 